import React from 'react';

const FilterList = props => {
  const { alltags, filters, onChange, resetFilters } = props;

  if (alltags) {
    const tagsHtml = [];
    const sortedTags = Object.values(alltags).sort((a, b) => {
      return (a.sort || 999) - (b.sort || 999);
    });

    sortedTags.forEach(tag => {
      if (alltags[tag.id].is_main || filters.indexOf(tag.id) > -1) {
        const classes = ['tag'];
        if (filters.indexOf(tag.id) > -1) classes.push('tag--selected');

        tagsHtml.push(
          <button
            key={tag.id}
            type="button"
            onClick={() => onChange(tag.id)}
            className={classes.join(' ')}
          >
            {alltags[tag.id].name}
          </button>,
        );
      }
    });

    if (filters.length !== 0) {
      tagsHtml.push(
        <button
          key={3e10}
          type="button"
          onClick={resetFilters}
          className='tag tags-reset'
        >
          Сбросить теги
          <span>&times;</span>
        </button>
      );
    }

    return (
      <section className="popup-nav__tags tags tags--white tags--outlined-blue">{tagsHtml}</section>
    );
  } else {
    return null;
  }
};

export default FilterList;
